import moment from 'moment'

export const isActiveDay = (date: string) => {
  return moment(date).isSame(moment(), 'day')
}
